import { API_URL } from '../config';
import axios from 'axios';

export const SOURCES_REQUEST = 'core/SOURCES_REQUEST';
export const SOURCES_RECEIVE = 'core/SOURCES_RECEIVE';
export const SOURCES_ERROR = 'core/SOURCES_ERROR';

export default () => {
    return (dispatch, getState) => {
        dispatch({
            type: SOURCES_REQUEST
        });
        return axios.get(API_URL + `/sources`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + getState().login.data
            }
        })
            .then(response => {
                dispatch({
                    type: SOURCES_RECEIVE,
                    payload: response.data
                });
            })
            .catch(error => {
                dispatch({
                    type: SOURCES_ERROR,
                    payload: error
                });
                // throw error;
            })
        ;
    }
}
